import { api } from './authService';

export interface ReportQuery {
  source_currency_code?: string;
  dest_currency_code?: string;
  type?: string;
  status?: string;
  disburse_type?: string;
  from_date: string; // Required - YYYY/MM/DD format
  to_date: string;   // Required - YYYY/MM/DD format
}

export interface CreateReportRequest {
  type: 'transactions-log';
  query: ReportQuery;
}

export interface ReportResponse {
  id: string;
  filename: string;
  file_url?: string;
  status: 'new' | 'pending' | 'completed' | 'failed';
}

export interface ReportNotification {
  status: 'completed' | 'failed';
  filename?: string;
  file_url?: string;
}

// Create a report request
export const createReport = async (request: CreateReportRequest): Promise<ReportResponse> => {
  try {
    console.log('Creating report with request:', request);
    const response = await api.post('/admin/reports', request);
    console.log('Report created successfully:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error creating report:', error);
    throw error;
  }
};

// Get report requests with optional filtering
export const getReports = async (params: {
  type?: string;
  status?: string;
  from?: number;
  to?: number;
  next_cursor?: string;
} = {}): Promise<{ reports: ReportResponse[]; next_cursor?: string }> => {
  try {
    const searchParams = new URLSearchParams();
    
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        searchParams.append(key, value.toString());
      }
    });

    const response = await api.get(`/admin/reports?${searchParams.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching reports:', error);
    throw error;
  }
};

// Get specific report by ID
export const getReportById = async (id: string): Promise<ReportResponse> => {
  try {
    const response = await api.get(`/admin/reports/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching report:', error);
    throw error;
  }
};

// Retry a failed report
export const retryReport = async (id: string, send_to_email?: boolean): Promise<ReportResponse> => {
  try {
    const response = await api.patch(`/admin/reports/${id}`, {
      action: 'retry',
      ...(send_to_email !== undefined && { send_to_email })
    });
    return response.data;
  } catch (error) {
    console.error('Error retrying report:', error);
    throw error;
  }
};

// Resign a completed report (regenerate file URL)
export const resignReport = async (id: string): Promise<ReportResponse> => {
  try {
    const response = await api.patch(`/admin/reports/${id}`, {
      action: 'resign'
    });
    return response.data;
  } catch (error) {
    console.error('Error resigning report:', error);
    throw error;
  }
};
